export const ENTITY_TYPE = {
    ANALYSIS: 'analysis',
    DASHBOARD: 'dashboard',
    REPORT_TEMPLATE: 'report_template',
    REPORT_INSTANCE: 'report_instance',
    AUTOMATION: 'automation',
    PRESET: 'preset',
    PERIOD_TEMPLATE: 'period_template',
    PERIOD_SWITCH: 'period_switch',
    FORM_FIELD: 'form_field',
} as const;
